import { 
  Sidebar, 
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
  SidebarToggle
} from '@merels/ui'
import { FolderOpen, User } from 'lucide-react'

interface SidebarNavProps {
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  routeView: 'list' | 'detail'
  userId: string | undefined
  onBackToProjects: () => void
}

export function SidebarNav({
  sidebarOpen,
  setSidebarOpen,
  routeView,
  userId,
  onBackToProjects,
}: SidebarNavProps) {
  return (
    <Sidebar open={sidebarOpen} onOpenChange={setSidebarOpen} className="border-r border-[#1e212f] bg-[#0d0e12]">
      <SidebarHeader className="flex h-11 items-center justify-between border-b border-[#1e212f] px-4 shrink-0">
        {sidebarOpen ? (
          <div className="flex items-center space-x-2">
            <div className="flex h-5 w-5 items-center justify-center rounded bg-primary/10 text-primary font-black text-[10px] tracking-tighter">M</div>
            <span className="font-bold uppercase tracking-wider text-gray-100">Merels Admin</span>
          </div>
        ) : (
          <div className="flex h-5 w-5 items-center justify-center rounded bg-primary/10 text-primary font-black text-[10px] tracking-tighter mx-auto">M</div>
        )}
        <SidebarToggle className="text-gray-400 hover:text-white" />
      </SidebarHeader>

      <SidebarContent className="flex flex-col space-y-1.5 px-3 py-4 flex-1">
        <button
          onClick={onBackToProjects}
          className={`flex items-center rounded-md px-3 py-2 text-xs font-medium transition-colors ${
            routeView === 'list'
              ? 'bg-primary/10 text-primary'
              : 'text-muted-foreground hover:bg-[#161822] hover:text-gray-200'
          }`}
        >
          <FolderOpen className={`h-4 w-4 shrink-0 ${sidebarOpen ? 'mr-2.5' : 'mx-auto'}`} />
          {sidebarOpen && <span>Projects</span>}
        </button>
      </SidebarContent>

      <SidebarFooter className="border-t border-[#1e212f] h-12 px-4 flex items-center justify-center shrink-0">
        {sidebarOpen ? (
          <div className="flex items-center space-x-2 w-full truncate">
            <User className="h-4 w-4 text-muted-foreground shrink-0" />
            <span className="text-[10px] text-muted-foreground font-mono truncate select-all">
              {userId}
            </span>
          </div>
        ) : (
          <User className="h-4 w-4 text-muted-foreground" />
        )}
      </SidebarFooter>
    </Sidebar>
  )
}
